// Keputusan murni buat interaksi chart. Sengaja NOL IMPORT biar bisa dijalanin
// langsung pakai node.

// Domain selebar nol bikin skala d3 bagi nol.
function jaminLebar(bawah, atas, fallbackMax) {
  if (atas > bawah) return [bawah, atas];
  return [bawah, bawah + (Number(fallbackMax) || 1)];
}

// Seri yang lagi ditampilin. `hidden` objek { [nama]: true }.
export function visibleDatasets(datasets, hidden) {
  const mati = hidden || {};
  return (datasets || []).filter((d) => d && !mati[d.name]);
}

// Domain satu sumbu dari seri yang dikirim. Nol selalu termasuk, dan nilai
// negatif melebarkan ke bawah.
export function domainFor(datasets, axis, fallbackMax) {
  const nilai = [];
  (datasets || []).forEach((d) => {
    if (d && d.axis === axis && d.interpolated) {
      (d.interpolated || []).forEach((v) => {
        if (typeof v === 'number' && Number.isFinite(v)) nilai.push(v);
      });
    }
  });
  if (nilai.length === 0) return jaminLebar(0, 0, fallbackMax);
  let min = nilai[0];
  let max = nilai[0];
  for (let i = 1; i < nilai.length; i += 1) {
    if (nilai[i] < min) min = nilai[i];
    if (nilai[i] > max) max = nilai[i];
  }
  return jaminLebar(Math.min(0, min), Math.max(0, max), fallbackMax);
}

// Domain yang dikunci menang atas hasil hitung ulang.
export function resolveDomain(locked, computed) {
  return Array.isArray(locked) && locked.length === 2 ? locked : computed;
}

// Rentang zoom setelah dinormalkan dan dijepit ke batas data. Balikin null
// kalau gak masuk akal — pemanggil pakai rentang penuh.
export function clampRange(range, extent) {
  if (!Array.isArray(range) || !Array.isArray(extent)) return null;
  const [a, b] = range;
  const [lo, hi] = extent;
  if (![a, b, lo, hi].every((v) => typeof v === 'number' && Number.isFinite(v))) return null;
  const mulai = Math.max(Math.min(a, b), Math.min(lo, hi));
  const selesai = Math.min(Math.max(a, b), Math.max(lo, hi));
  if (!(selesai > mulai)) return null;
  return [mulai, selesai];
}

function sel(nilai) {
  if (typeof nilai === 'number' && !Number.isFinite(nilai)) return '';
  const teks = nilai === null || nilai === undefined ? '' : String(nilai);
  return /[",\n]/.test(teks) ? `"${teks.replace(/"/g, '""')}"` : teks;
}

// CSV dari apa yang lagi tampil. `formatTs` dikirim pemanggil supaya waktunya
// ikut zona browser, bukan UTC.
export function toCsv({ timestamps = [], datasets = [], formatTs }) {
  const judul = ['time'].concat(datasets.map((d) => sel(d.name))).join(',');
  const baris = timestamps.map((ts, i) => [sel(formatTs(ts))]
    .concat(datasets.map((d) => sel((d.data || [])[i])))
    .join(','));
  return `${[judul].concat(baris).join('\n')}\n`;
}
